"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = index;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function index(props) {
  var paddingTopNum = props.paddingTopNum,
    paddingBottomNum = props.paddingBottomNum,
    flexTitle = props.flexTitle,
    style = props.style,
    isPadding = props.isPadding,
    isFooterPart = props.isFooterPart,
    isCombination = props.isCombination;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "common-container",
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('common-container-wrap', {
      'is-has-title': flexTitle,
      'is-padding': isPadding,
      'padding-top-pc60-mo40': paddingTopNum === '60',
      'padding-top-pc40-mo24': paddingTopNum === '40',
      'padding-top-pc0-mo0': paddingTopNum === '0',
      'padding-bottom-pc60-mo40': paddingBottomNum === '60',
      'padding-bottom-pc40-mo24': paddingBottomNum === '40',
      'padding-bottom-pc0-mo0': paddingBottomNum === '0',
      'combination-not-footer-part': isCombination && !isFooterPart && !paddingBottomNum,
      combination: isCombination && !paddingTopNum
    })
  }, props === null || props === void 0 ? void 0 : props.children));
}